import { Job } from '@/class/model/booking/Job'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { cache, cacheName } from '@/utils/cacheManager'

export class TabVesselEqPM {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    this.view = view
    this.currentVessel = null
    this.title = ''
    this.selectedJobs = null // 选择edi
    this.lclslaveEnabled = false
    this.lclslaveEnabledExcludeExportToImport = false
    this._allowEditingVessel = false
    this._voyages = null
    this.vesselList = []
    this.statusFlag = new Map()
    this.syncSignDateBl = 0
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    this.view.context = context
  }
  get user() {
    return this.view.context.user
  }
  set user(user) {
    this.view.context.user = user
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    this.view.context.companyList = companyList
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    this.view.config = config
  }
  get job() {
    return this.view.form
  }
  set job(job) {
    this.view.form = job
  }
  async init() {
  }
  async changeJob() {
    await this.initPushDataChange()
  }
  /**
   * fill view
   */
  async fillView() {
  }
  print() {
  }
  /**
   * 推送数据改变标识
   */
  async initPushDataChange() {
    const job = this.job
    if (job.uuid) {
      const lclMaster = await new AirExportJob(job).getLclMaster()
      const loadJob = lclMaster !== null ? lclMaster : job
      await new Job(loadJob).loadPushHistoryLogs()
    }
  }
  /**
   * MBL 查看详细信息
   */
  async showMBLDetailBtnClickHandler() {
    await cache.load(cacheName.CONFIG)
    const consoleURL = cache.config.get('mawbNoDetailUrl')
    // 对按钮点击进行埋点
    if (!this.job.mbl || this.job.mbl.replace('-', '').length !== 11) {
      return
    } else {
      if (consoleURL) {
        const el = document.createElement('a')
        document.body.appendChild(el)
        el.href = consoleURL + '?MAWB=' + encodeURIComponent(this.job.mbl.replace('-', ''))
        el.target = '_blank'
        el.click()
        document.body.removeChild(el)
      } else {
        this.view.$message.warning(this.view.$t('queryJob.PleaseMaintainTheJumpAddress'))
      }
    }
  }
}
